export default {
  header: {
    projectName: 'Название проекта',
    export: 'Экспорт',
    debug: 'Отладка',
    success: 'Успех',
    failed: 'Ошибка',
    generating: 'Создание видео...',
    updateNameFailed: 'Не удалось обновить название проекта',
    menu: 'Меню',
    settings: 'Настройки',
    shortcuts: 'Горячие клавиши',
    about: 'О программе',
    darkMode: 'Темный режим',
    lightMode: 'Светлый режим',
    settingsComingSoon: 'Настройки скоро появятся',
    shortcutsComingSoon: 'Горячие клавиши скоро появятся',
    aboutComingSoon: 'Информация о программе скоро появится',
    language: 'Язык',
    dimensions: 'Размеры',
    canvas: 'Холст',
    view: 'Вид',
    general: 'Общее'
  },
  menu: {
    media: 'Медиа',
    text: 'Текст'
  },
  loading: {
    core: 'Загрузка ядра...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: 'Публичная бета',
    betaDisclaimer: 'Бета-версия, сохранность данных не гарантируется',
    newProject: 'Новый проект',
    backupFolder: 'Папка резервного копирования',
    documentation: 'Документация',
    recentProjects: 'Недавние проекты',
    viewAll: 'Посмотреть все ({count})',
    noProjects: 'Проектов пока нет. Создайте свой первый проект, чтобы начать!',
    login: 'ВОЙТИ',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: 'БЛОГ',
    projectCreated: 'Проект создан',
    projectCreatedDesc: 'Новый проект успешно создан',
    projectDeleted: 'Проект удален',
    projectDeletedDesc: 'Проект успешно удален',
    deleteConfirmation: 'Вы уверены, что хотите удалить этот проект? Это действие нельзя отменить.',
    migrationFailed: 'Ошибка миграции',
    migrationFailedDesc: 'Не удалось перенести данные из localStorage',
    loadFailed: 'Ошибка загрузки',
    loadFailedDesc: 'Не удалось загрузить проекты',
    creationFailed: 'Ошибка создания',
    creationFailedDesc: 'Не удалось создать новый проект',
    deletionFailed: 'Ошибка удаления',
    deletionFailedDesc: 'Не удалось удалить проект'
  },
  timeline: {
    autoSaveFailed: 'Ошибка автосохранения',
    autoSaveFailedDesc: 'Не удалось автоматически сохранить проект',
    loadFailed: 'Ошибка загрузки',
    loadFailedDesc: 'Не удалось загрузить проект. Перенаправление на главную...',
    mainTrack: 'Основная дорожка',
    undo: 'Отменить',
    redo: 'Повторить',
    split: 'Разделить',
    delete: 'Удалить'
  },
  attributes: {
    properties: 'Свойства',
    position: 'Позиция',
    scale: 'Масштаб',
    animation: 'Анимация',
    basic: 'Основные',
    mute: 'Без звука',
    text: 'Текст',
    fontSize: 'Размер шрифта',
    content: 'Содержание',
    fontFamily: 'Шрифт',
    direction: 'Направление текста',
    color: 'Цвет',
    stroke: 'Обводка',
    background: 'Фон',
    video: 'Видео',
    rotate: 'Поворот',
    backgroundColor: 'Цвет фона',
    opacity: 'Прозрачность',
    blend: 'Смешивание',
    filter: 'Фильтр',
    effect: 'Эффект',
    transition: 'Переход',
    speed: 'Скорость',
    volume: 'Громкость'
  },
  router: {
    editor: 'Видеоредактор',
    preview: 'Предпросмотр',
    storyboard: 'Раскадровка - AI Видео Агент'
  },
  placeholder: {
    text: 'Пожалуйста, введите текст',
    input: 'Пожалуйста, введите'
  },
  error: {
    parseAudio: 'Ошибка анализа аудио',
    parseImage: 'Ошибка анализа изображения',
    parseVideo: 'Ошибка анализа видео',
    noProject: 'Пожалуйста, сначала создайте или откройте проект',
    invalidFileType: 'Неверный тип файла'
  },
  media: {
    video: 'Видео',
    image: 'Изображение',
    audio: 'Аудио',
    dropToUpload: 'Перетащите файлы сюда для загрузки'
  },
  common: {
    defaultText: 'Текст по умолчанию',
    delete: 'Удалить'
  }
};
